let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("81UW2")).then(() => parcelRequire('aHTjn'));